import { useEffect, useRef } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

interface AnimatedNumberProps {
  value: number;
  decimals?: number;
  suffix?: string;
  prefix?: string;
  duration?: number;
  className?: string;
}

export function AnimatedNumber({ 
  value, 
  decimals = 0, 
  suffix = '', 
  prefix = '',
  duration = 2,
  className = ''
}: AnimatedNumberProps) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (inView) {
      hasAnimated.current = true;
    }
  }, [inView]);

  return (
    <div ref={ref} className={className}>
      {inView || hasAnimated.current ? (
        <CountUp
          start={0}
          end={value}
          decimals={decimals}
          duration={duration}
          suffix={suffix}
          prefix={prefix}
          separator=","
        />
      ) : (
        <span>0{suffix}</span>
      )}
    </div>
  );
}
